import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PaymentMethodTokenData from './paymentMethodTokenData.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Callout emoji='ℹ️' mdxType="Callout">
If you set `paymentHandling` to `MANUAL`, implementing this is mandatory.
    </Callout>
    <Group summary='Parameters' mdxType="Group">
      <Item title='paymentMethodTokenData' subtitle='PrimerPaymentMethodTokenData' mdxType="Item">
  <PaymentMethodTokenData mdxType="PaymentMethodTokenData" />
      </Item>
      <Item title='handler' subtitle='OnTokenizeSuccessHandler' mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <Item title="handleSuccess" subtitle='() => void' mdxType="Item">
    Display a success screen.
          </Item>
          <Item title="handleFailure" subtitle='(errorMessage: string) => void' mdxType="Item">
            <p>{`Display `}<inlineCode parentName="p">{`errorMessage`}</inlineCode>{` as an error or failure message.`}</p>
          </Item>
          <Item title="continueWithNewClientToken" subtitle='(clientToken: string) => void' mdxType="Item">
            <p>{`Continue the payment flow using the given `}<inlineCode parentName="p">{`clientToken`}</inlineCode>{`.`}</p>
          </Item>
        </Group>
      </Item>
    </Group>
    <p>{`Called after a customer submitted their payment data and the payment details have been tokenized.
You'll receive a `}<inlineCode parentName="p">{`paymentMethodToken`}</inlineCode>{` in `}<inlineCode parentName="p">{`onTokenizeSuccess()`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://primer.io/docs/api/api-reference/payments-api/create-payment"
          }}>{`Create a payment request`}</a>{` passing the `}<inlineCode parentName="p">{`paymentMethodToken`}</inlineCode>{` to your backend`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If the payment is successful, call `}<inlineCode parentName="p">{`handler.handleSuccess()`}</inlineCode>{` in order to display a success screen`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If the payment is unsuccessful, call `}<inlineCode parentName="p">{`handler.handleFailure(errorMessage)`}</inlineCode>{` to display an error or failure message`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Payments API may return a new `}<inlineCode parentName="p">{`clientToken`}</inlineCode>{` for additional steps (in the `}<inlineCode parentName="p">{`requiredActions`}</inlineCode>{` on the response). In this case, call `}<inlineCode parentName="p">{`handler.continueWithNewClientToken(clientToken)`}</inlineCode>{` to continue with the payment flow`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      